function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M302.233 64.648C225.548 5.761 194.592 124.817 187.546 165.78c-7.046 40.963-39.355 50.436-116.765 40.963-77.41-9.473-26.667 125.584 68.767 175.586 95.435 50.003 229.039 19.652 253.773-76.818 24.735-96.47-14.403-181.975-91.088-240.863z",
  fill: "currentColor",
  stroke: "currentColor"
});

function SvgBlob2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 451,
    height: 447,
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDUxIiBoZWlnaHQ9IjQ0NyIgdmlld0JveD0iMCAwIDQ1MSA0NDciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0zMDIuMjMzIDY0LjY0ODVDMjI1LjU0OCA1Ljc2MTMgMTk0LjU5MiAxMjQuODE3IDE4Ny41NDYgMTY1Ljc4QzE4MC41IDIwNi43NDMgMTQ4LjE5MSAyMTYuMjE2IDcwLjc4MSAyMDYuNzQzQy02LjYyODUyIDE5Ny4yNyA0NC4xMTM3IDMzMi4zMjcgMTM5LjU0OCAzODIuMzI5QzIzNC45ODMgNDMyLjMzMiAzNjguNTg3IDQwMS45ODEgMzkzLjMyMSAzMDUuNTExQzQxOC4wNTYgMjA5LjA0MSAzNzguOTE4IDEyMy41MzYgMzAyLjIzMyA2NC42NDg1WiIgZmlsbD0iY3VycmVudENvbG9yIiBzdHJva2U9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";
export { SvgBlob2 as ReactComponent };